import { Injectable, Injector } from "@angular/core";
import { ReplaySubject, Observable, of } from "rxjs";
import { MessageNotificationService } from "../../../component/message-notification/message-notification.service";

@Injectable({ providedIn: 'root' })
export class AuthStateService {

  private authData: { verified2Fa: boolean; platform: number; authorities:string[] } | null = null;
  private permissions: string[] | null = null;
  private ready$ = new ReplaySubject<void>(1);
  private _ws: MessageNotificationService | null = null;

  constructor(private injector: Injector) {}

  private get ws(): MessageNotificationService {
    if (!this._ws) {
      this._ws = this.injector.get(MessageNotificationService);
    }
    return this._ws;
  }

  setAuth(auth: { verified2Fa: boolean; platform: number; authorities:string[] }) {
    this.authData = auth;
    this.emitIfReady();
  }

  setPermissions(permissions: string[]) {
    this.permissions = permissions;
    this.emitIfReady();
  }

  getAuth() { return this.authData; }
  getPermissions() { return this.permissions; }
  isAdmin(): boolean { return this.authData?.platform === 0; }
  isReady() { return this.authData !== null && this.permissions !== null; }

  whenReady(): Observable<void> {
    if (this.isReady()) return of(undefined);
    return this.ready$.asObservable();
  }

  reset() {
    this.authData = null;
    this.permissions = null;
    this.ready$ = new ReplaySubject<void>(1);
    this.ws.disconnect();
  }

  private emitIfReady() {
    if (this.isReady()) {
      this.ready$.next();
      if (this.authData?.verified2Fa) {
        if (!this.ws.isConnectedWebsocket()) {
          this.ws.connect();
        }
      }
    }
  }
}